import { api, ApiRoutes } from './ApiService'
import { OnboardingCustomerPagination, OnboardingCustomerRow } from '../types/OnboardingCustomer'

export type FetchOnboardingCustomersResult = {
    customers: OnboardingCustomerRow[]
    pagination?: OnboardingCustomerPagination
}

export const fetchOnboardingCustomers = async (
    page: number = 1,
    limit: number = 20
): Promise<FetchOnboardingCustomersResult> => {
    const response = await api.get(ApiRoutes.ONBOARDING_CUSTOMERS, undefined, {
        page: page.toString(),
        limit: limit.toString(),
    })
    const customers = response.data?.data?.customers
    const pagination = response.data?.pagination
    return {
        customers: Array.isArray(customers) ? customers : [],
        pagination,
    }
}
